var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-verified"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    x: 4.16667,
    y: 4.16663,
    width: 11.6667,
    height: 11.6667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1667 10L17.1333 7.675L17.4167 4.6L14.4083 3.91667L12.8333 1.25L10 2.46667L7.16666 1.25L5.59166 3.90833L2.58333 4.58333L2.86666 7.66667L0.833328 10L2.86666 12.325L2.58333 15.4083L5.59166 16.0917L7.16666 18.75L10 17.525L12.8333 18.7417L14.4083 16.0833L17.4167 15.4L17.1333 12.325L19.1667 10ZM8.40833 13.9333L5.24166 10.7583L6.475 9.525L8.40833 11.4667L13.2833 6.575L14.5167 7.80833L8.40833 13.9333Z",
    fill: "#3F9AF7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVerified);
export default __webpack_public_path__ + "static/media/ic_verified.18cb46993a9491f2cbf782ef9045ce5c.svg";
export { ForwardRef as ReactComponent };